import { render, staticRenderFns } from "./xing-zheng-fu-wu.vue?vue&type=template&id=b925709e&scoped=true&"
import script from "./xing-zheng-fu-wu.vue?vue&type=script&lang=js&"
export * from "./xing-zheng-fu-wu.vue?vue&type=script&lang=js&"
import style0 from "./xing-zheng-fu-wu.vue?vue&type=style&index=0&id=b925709e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b925709e",
  null
  
)

export default component.exports